import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/NFTCard.css"; // your CSS

const NFTCard = ({ nft }) => {
  // Use priceETH and priceUSD directly with fallback
  const nftEth = nft.priceETH || "0 ETH";
  const nftUsd = nft.priceUSD || "$0.00 USD";

  return (
    <Card className="nft-card h-100 shadow-sm">
      {/* Image */}
      <div className="nft-image-wrapper">
        <img src={nft.image} alt={nft.name} />
      </div>

      <Card.Body className="nft-card-body">
        <Card.Title className="nft-card-title">{nft.name}</Card.Title>
        <Card.Text className="nft-card-artist">By {nft.artist}</Card.Text>

        {/* Show USD and ETH */}
        <Card.Text className="nft-card-price">
          {nftUsd} ({nftEth})
        </Card.Text>

        <Button
          as={Link}
          to={`/nft/${nft.id}`}
          variant="primary"
          className="nft-card-btn"
        >
          View Details
        </Button>
      </Card.Body>
    </Card>
  );
};

export default NFTCard;
